import {
  CREATE_ORGANIZATION_PATH,
  GET_ORGANIZATION_PATH,
  GET_ORGANIZATIONS_PATH,
  UPDATE_ORGANIZATIONS_PATH,
  CREATE_SITE_PATH,
  GET_SITES_BY_ORGANIZATION_PATH,
  GET_SITE_PATH,
  UPDATE_SITE_PATH,
  DELETE_SITE_PATH,
  CREATE_FLOOR_PATH,
  GET_FLOORS_BY_SITE_PATH,
  UPDATE_FLOOR_PATH,
  DELETE_FLOOR_PATH,
  CREATE_SPACE_PATH,
  GET_SPACES_BY_FLOOR_PATH,
  UPDATE_SPACE_PATH,
  DELETE_SPACE_PATH,
  FETCH_DASHBOARD_DATA_PATH,
  GET_SPACE_TYPES_PATH,
  VALIDATE_DEVICE_NAME_PATH,
  SAVE_DEVICE_USER_ASSOCIATION_PATH,
  GET_DEVICES_PATH,
  GET_CAMERAS_PATH,
  UPDATE_DEVICE_ASSOCIATION_PATH,
  GET_DEVICE_STREAM_URL_PATH,
  SEND_STREAMING_COMMAND_PATH,
  GET_HUBS_BY_SITE_PATH,
  INITIATE_NVR_ONBOARDING_PATH,
  DISCOVER_CAMERAS_PATH,
  GET_ONBOARDING_STATUS_PATH,
  GET_DISCOVERY_CANDIDATES_PATH,
  PROVISION_CAMERAS_PATH,
  DECOMMISSIONED_DEVICES_PATH,
  GET_CATALOGS_PATH,
  GET_CATALOGS_ALL_PATH,
  CREATE_CATALOG_PATH,
  GET_CATALOG_PATH,
  UPDATE_CATALOG_PATH,
  DELETE_CATALOG_PATH,
  GET_DEVICE_CATEGORIES_PATH,
  GET_DEVICE_CATEGORIES_BY_CATALOG_PATH,
  CREATE_DEVICE_CATEGORY_PATH,
  UPDATE_DEVICE_CATEGORY_PATH,
  DELETE_DEVICE_CATEGORY_PATH,
  GET_MODEL_GROUPS_PATH,
  GET_MODEL_GROUPS_BY_CATEGORY_PATH,
  CREATE_MODEL_GROUP_PATH,
  UPDATE_MODEL_GROUP_PATH,
  DELETE_MODEL_GROUP_PATH,
  GET_DEVICE_MODELS_PATH,
  CREATE_DEVICE_MODEL_PATH,
  GET_DEVICE_MODEL_PATH,
  UPDATE_DEVICE_MODEL_PATH,
  DELETE_DEVICE_MODEL_PATH,
  JUMP_PLAYBACK_PATH,
  GET_PLAYBACK_CHUNK_PATH,
  GET_PLAYBACK_DATES_PATH,
  GET_MY_PERMISSIONS_PATH,
  GET_ROLES_PATH,
  GET_PERMISSIONS_PATH,
  GET_MEMBERS_PATH,
  GET_MEMBER_INVITATIONS_PATH,
  CREATE_MEMBER_PATH,
  UPDATE_MEMBER_STATUS_PATH,
  DELETE_MEMBER_PATH,
  EDIT_MEMBER_ROLE_PATH,
  GET_EVENTS_PATH,
  GET_MEMBER_AUDIT_HISTORY_PATH,
  UPDATE_WORKFLOW_STATUS_PATH,
  GET_EVENT_SEVERITY_COUNT_PATH,
} from "./CONSTANTS"
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
  patchRequest,
} from "./axiosRequests"

// ==========================================
// Organization API calls
// ==========================================
export const createOrganization = (orgData) => {
  return postRequest(CREATE_ORGANIZATION_PATH(), orgData, null)
}

export const getOrganizations = async () => {
  return getRequest(GET_ORGANIZATION_PATH(), null)
}

// Returns full hierarchy: Org → Sites → Floors → Spaces in one call
export const getOrganization = async (orgId) => {
  return getRequest(GET_ORGANIZATIONS_PATH(orgId), null)
}

export const updateOrganization = async (orgId, reqBody) => {
  return putRequest(UPDATE_ORGANIZATIONS_PATH(orgId), reqBody)
}

export const deleteOrganization = (orgId) => {
  return deleteRequest(GET_ORGANIZATIONS_PATH(orgId), null)
}

// ==========================================
// Site API calls
// ==========================================
export const createSite = (siteData) =>
  postRequest(CREATE_SITE_PATH(), siteData)

export const getSitesByOrganization = (orgId) =>
  getRequest(GET_SITES_BY_ORGANIZATION_PATH(orgId), null)

export const getSite = (siteId) => getRequest(GET_SITE_PATH(siteId), null)

export const updateSite = (siteId, siteData) =>
  putRequest(UPDATE_SITE_PATH(siteId), siteData)

export const deleteSite = (siteId) =>
  deleteRequest(DELETE_SITE_PATH(siteId), null)

// ==========================================
// Floor API calls
// ==========================================
export const createFloor = (floorData) =>
  postRequest(CREATE_FLOOR_PATH(), floorData)

export const getFloorsBySite = (siteId) =>
  getRequest(GET_FLOORS_BY_SITE_PATH(siteId), null)

export const updateFloor = (floorId, floorData) =>
  putRequest(UPDATE_FLOOR_PATH(floorId), floorData)

export const deleteFloor = (floorId) =>
  deleteRequest(DELETE_FLOOR_PATH(floorId), null)

// ==========================================
// Space API calls
// ==========================================
export const createSpace = (spaceData) =>
  postRequest(CREATE_SPACE_PATH(), spaceData)

export const getSpacesByFloor = (floorId) =>
  getRequest(GET_SPACES_BY_FLOOR_PATH(floorId), null)

export const updateSpace = (spaceId, spaceData) =>
  putRequest(UPDATE_SPACE_PATH(spaceId), spaceData)

export const deleteSpace = (spaceId) =>
  deleteRequest(DELETE_SPACE_PATH(spaceId), null)

// ==========================================
// Dashboard API calls
// ==========================================
export const fetchDashboardData = () =>
  getRequest(FETCH_DASHBOARD_DATA_PATH(), null)

// ==========================================
// Add more API functions as your endpoints grow
// ==========================================

export const getSpaceTypes = () => getRequest(GET_SPACE_TYPES_PATH(), null)

// ==========================================
// Device API calls
// ==========================================
export const validateDeviceName = (deviceName) =>
  getRequest(VALIDATE_DEVICE_NAME_PATH(deviceName), null)

export const saveDeviceUserAssociation = (data) =>
  postRequest(SAVE_DEVICE_USER_ASSOCIATION_PATH(), data)

export const getDevices = (params) => getRequest(GET_DEVICES_PATH(), { params })

export const getCameras = (params) => getRequest(GET_CAMERAS_PATH(), { params })

export const updateDeviceAssociation = (id, data) =>
  putRequest(UPDATE_DEVICE_ASSOCIATION_PATH(id), data)

export const getDeviceStreamUrl = (deviceId) =>
  getRequest(GET_DEVICE_STREAM_URL_PATH(deviceId), null)

export const sendStreamingCommand = (thingNames, action) => {
  if (Array.isArray(thingNames)) {
    return postRequest(SEND_STREAMING_COMMAND_PATH(), { thingNames, action })
  }
  return postRequest(SEND_STREAMING_COMMAND_PATH(), {
    thingName: thingNames,
    action,
  })
}

export const getHubsBySite = (params) =>
  getRequest(GET_HUBS_BY_SITE_PATH(), { params })

export const initiateNvrOnboarding = (data) =>
  postRequest(INITIATE_NVR_ONBOARDING_PATH(), data)

export const discoverCameras = (nvrId) =>
  postRequest(DISCOVER_CAMERAS_PATH(nvrId), null)

export const getOnboardingStatus = (commandId) =>
  getRequest(GET_ONBOARDING_STATUS_PATH(commandId), null)

export const getDiscoveryCandidates = (jobId) =>
  getRequest(GET_DISCOVERY_CANDIDATES_PATH(jobId), null)

export const provisionCameras = (data) =>
  postRequest(PROVISION_CAMERAS_PATH(), data)

// ==========================================
// NVR Resync API calls
// ==========================================
export const resyncNvrCredentials = (nvrId, credentials) =>
  postRequest(`/nvr/${nvrId}/resync-credentials`, credentials)

export const initiateNvrResync = (nvrId, data = {}) =>
  postRequest(
    `/nvr/${nvrId}/discovery/resync`,
    data || { forceRediscovery: true, includeComparison: true },
  )

export const getCameraComparison = (jobId) =>
  getRequest(`/nvr/discovery/${jobId}/comparison`, null)

// ==========================================
// Device delete API call
// ==========================================
// associationId = device_user_association PK (the device-list row id).
// For NVR / NVR-camera deletes, credentials = { username, password } are required
// (the hub authenticates against the NVR). Standalone cameras ignore credentials.
// postRequest unwraps to the response body, so DTO fields (status, cmdId, message,
// websocketJobId) are at the top level — not under `.data`.
export const deleteDeviceApi = (associationId, credentials = {}) =>
  postRequest(`/devices/${associationId}/delete`, credentials || {})

export const decommissionDeviceApi = (params) =>
  getRequest(DECOMMISSIONED_DEVICES_PATH(), { params })

// ==========================================
// Catalog API calls
// ==========================================
export const getCatalogs = (params) => getRequest(GET_CATALOGS_PATH(params))
export const getCatalogsAll = () => getRequest(GET_CATALOGS_ALL_PATH())
export const createCatalog = (data) => postRequest(CREATE_CATALOG_PATH(), data)
export const getCatalog = (id) => getRequest(GET_CATALOG_PATH(id))
export const updateCatalog = (id, data) =>
  putRequest(UPDATE_CATALOG_PATH(id), data)
export const deleteCatalog = (id) => deleteRequest(DELETE_CATALOG_PATH(id))

export const getDeviceCategories = (params) =>
  getRequest(GET_DEVICE_CATEGORIES_PATH(params))
export const getDeviceCategoriesByCatalog = (catalogId) =>
  getRequest(GET_DEVICE_CATEGORIES_BY_CATALOG_PATH(catalogId))
export const createDeviceCategory = (catalogId, data) =>
  postRequest(CREATE_DEVICE_CATEGORY_PATH(catalogId), data)
export const updateDeviceCategory = (id, data) =>
  putRequest(UPDATE_DEVICE_CATEGORY_PATH(id), data)
export const deleteDeviceCategory = (id) =>
  deleteRequest(DELETE_DEVICE_CATEGORY_PATH(id))

export const getModelGroups = (params) =>
  getRequest(GET_MODEL_GROUPS_PATH(params))
export const getModelGroupsByCategory = (categoryId) =>
  getRequest(GET_MODEL_GROUPS_BY_CATEGORY_PATH(categoryId))
export const createModelGroup = (categoryId, data) =>
  postRequest(CREATE_MODEL_GROUP_PATH(categoryId), data)
export const updateModelGroup = (id, data) =>
  putRequest(UPDATE_MODEL_GROUP_PATH(id), data)
export const deleteModelGroup = (id) =>
  deleteRequest(DELETE_MODEL_GROUP_PATH(id))

export const getDeviceModels = (params) =>
  getRequest(GET_DEVICE_MODELS_PATH(params))
export const createDeviceModel = (groupId, data) =>
  postRequest(CREATE_DEVICE_MODEL_PATH(groupId), data)
export const getDeviceModel = (id) => getRequest(GET_DEVICE_MODEL_PATH(id))
export const updateDeviceModel = (id, data) =>
  putRequest(UPDATE_DEVICE_MODEL_PATH(id), data)
export const deleteDeviceModel = (id) =>
  deleteRequest(DELETE_DEVICE_MODEL_PATH(id))

// ==========================================
// Playback API calls
// ==========================================
export const jumpPlayback = (requestBody) =>
  postRequest(JUMP_PLAYBACK_PATH(), requestBody)

export const getPlayBackChunks = (requestBody) =>
  postRequest(GET_PLAYBACK_CHUNK_PATH(), requestBody)

export const getPlayBackDates = (requestBody) =>
  postRequest(GET_PLAYBACK_DATES_PATH(), requestBody)

// ==========================================
// RBAC API calls
// ==========================================
export const getMyPermissions = () => getRequest(GET_MY_PERMISSIONS_PATH())

export const getRoles = () => getRequest(GET_ROLES_PATH())

export const getPermissions = () => getRequest(GET_PERMISSIONS_PATH())

// ==========================================
// Members API call
// ==========================================
export const membersApi = (params) => getRequest(GET_MEMBERS_PATH(), { params })

export const memberInvitationsApi = (params) =>
  getRequest(GET_MEMBER_INVITATIONS_PATH(), { params })

export const updateMemberStatus = (userId, status, reason) =>
  patchRequest(UPDATE_MEMBER_STATUS_PATH(userId), {
    status,
    ...(reason ? { reason } : {}),
  })

export const inviteMember = (data) => postRequest(CREATE_MEMBER_PATH(), data)

export const deleteMember = (userId) =>
  deleteRequest(DELETE_MEMBER_PATH(userId))

export const editMemberRole = (userId, payload) =>
  putRequest(EDIT_MEMBER_ROLE_PATH(userId), payload)

export const auditHistoryApi = (userId) =>
  getRequest(GET_MEMBER_AUDIT_HISTORY_PATH(userId))

// events
export const getEvents = (params) => getRequest(GET_EVENTS_PATH(params))

export const updateWorkflowStatus = (eventId, payload) =>
  patchRequest(UPDATE_WORKFLOW_STATUS_PATH(eventId), payload)

export const getSeverityCount = (params) =>
  getRequest(GET_EVENT_SEVERITY_COUNT_PATH(params))
